import { generatePath, useMatches, type UIMatch } from "react-router-dom";

import type { NavTabsHandle } from "components/navbar/types";

export const useNavTabsFromHandle = () => {
  const matches = useMatches() as Array<UIMatch<unknown, NavTabsHandle>>;

  const navTabsMatches = matches
    .filter((match) => match.handle)
    .filter((handleMatch) => handleMatch.handle.navTabs);

  const matchWithPrimaryHandle = navTabsMatches.find(
    (match) => match.handle.navTabs.primaryTabs,
  );

  const matchWithSecondaryHandle = navTabsMatches.find(
    (match) => match.handle.navTabs.secondaryTabs,
  );

  const withOutcomeScenarios = navTabsMatches.some(
    (match) => match.handle.navTabs.withOutcomeScenarios,
  );

  const primaryTabs = matchWithPrimaryHandle?.handle.navTabs.primaryTabs;
  // assumes secondary tabs
  const secondaryTabs =
    matchWithSecondaryHandle?.handle.navTabs.secondaryTabs?.map((tab) => ({
      ...tab,
      link: generatePath(
        `${tab.link}/${matchWithSecondaryHandle.params.wellIdName ?? ""}`,
      ),
    }));

  return {
    primaryTabs,
    secondaryTabs,
    withOutcomeScenarios,
    primaryDefaultTab:
      primaryTabs?.find((tab) =>
        matches.some((m) => m.pathname.startsWith(tab.link ?? "")),
      )?.id ?? "",
    secondaryDefaultTab:
      secondaryTabs?.find((tab) =>
        matches.some((m) => m.pathname.startsWith(tab.link ?? "")),
      )?.id ?? "",
  };
};
